<template lang="pug">
v-app.contacts-page
  xo-toolbar
  .contacts-section.mx-auto(style="max-width: 1600px; width: 100%")
    .contacts-banner
      .vertical-border-orange
      .text-container
        p.subtitle.font-weight-medium See how we can multiply your productivity while saving your energy.

      v-spacer
      .d-flex.avatar-container
        img.mr-1.center.img-contact1.small-avatar(
          src="/images/new/contacts/Contact1.jpg"
        )
        img.mr-1.left.img-contact2(src="/images/new/contacts/Contact2.png")

    .testimonial-container
      .d-flex.flex-column.align-center.text-center
        p.contacts-title.font-weight-medium It's time to step off the hamster wheel and start living life!
        p.contacts-title.font-weight-medium Book a Discovery Call now.

      .d-flex.justify-content-center
        .testimonial-list.d-flex.justify-content-space-around.start.align-items-center
          v-sheet.testimonial-card-1
            p.testimonial-details During our <strong class="text-orange">45 minutes</strong> together, we'll discuss your unique situation, where you desire to go, and how we can help you get there.
            p.testimonial-details.mt-3.pr-3 This call is <strong class="text-black">100% free</strong> and there is zero obligation to continue working together.

          v-sheet.testimonial-card-2
            p.testimonial-details When you click the <strong class="text-orange">"Ask Us!"</strong> button, you will be directed to a booking page. There, you can select a date and time that work best for you. If you can't find a suitable time, simply email us at <a href = "mailto: hello@justask.ph" target="_blank" style="text-decoration: none"><b class="text-blue">hello@justask.ph</b></a> and we'll work something out. If you have any queries, we usually respond within one business day.
            p.testimonial-details.mt-3 You will also be prompted to answer a few questions. That way we can get to know you better before we meet.

          .contacts.d-flex.align-items-center.justify-content-center
            .d-flex.flex-column.justify-content-center
              a.v-btn.contact-btn.mb-2(
                href="https://calendly.com/justaskph/45min",
                target="_blank"
              ) ASK US!
              .contact-no.d-flex.flex-inline.align-items-center.mb-2
                v-icon(color="#009cb1") mdi-cellphone
                p.m-0.text-blue +63 936 261 2328

              .contacts-logo-container.d-flex.justify-start
                a(
                  href="https://www.facebook.com/justaskphilippines",
                  target="_blank",
                  style="text-decoration: none"
                ): v-icon(
                  color="#009cb1"
                ) mdi-facebook
                a(
                  href="https://www.instagram.com/justaskph/",
                  target="_blank",
                  style="text-decoration: none"
                ): v-icon(
                  color="#009cb1"
                ) mdi-instagram
                a(
                  href=" https://www.linkedin.com/company/justask-ph/",
                  target="_blank",
                  style="text-decoration: none"
                ): v-icon(
                  color="#009cb1"
                ) mdi-linkedin
                a(
                  href="mailto: hello@justask.ph",
                  target="_blank",
                  style="text-decoration: none"
                ): v-icon(
                  color="#009cb1"
                ) mdi-email-outline
</template>

<script>
export default {
    data() {
        return {
            avatar: [
                "Logo apperPH",
                "Logo Area63",
                "Logo BGA",
                "LogoDigitalMinds",
                "Logo Homeopathy PH",
                "Logo mocean-DkBlue",
                "Logo PixOwl",
                "Logo Sprinkle FIC",
                "LogoTheSecretSauce",
                "LogoVIPTraveler",
                "Logo Wivity",
                "Logo YGG Pinas",
                "Logo YGG",
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.text-orange {
    color: #f15c24;
}
.text-blue {
    color: #009cb1;
}
.contacts-page {
    font-family: GothamRounded;
}
//large
@media (min-width: 1265px) {
    .contacts-page {
        .contacts-section {
            margin-top: 60px;
            .contacts-banner {
                display: flex;
                align-items: center;
                background-color: #fdc321;
                padding: 0 60px;

                .avatar-container {
                    background-color: #fdc321;

                    img.img-contact1 {
                        height: 400px;
                        width: 305px;
                        object-fit: cover;
                    }
                    img.img-contact2 {
                        height: 400px;
                        width: 443px;
                        object-fit: cover;
                        object-position: 5%;
                    }

                    .center {
                        object-position: 20% 0;
                    }
                    .left {
                        object-position: 80% 0;
                    }
                    .mr-1 {
                        margin-right: 5px;
                    }
                }
                .text-container {
                    max-width: 500px;
                    .subtitle {
                        line-height: 26px;
                        font-size: 1.3rem;
                        font-style: italic;
                        font-weight: 550;
                        padding: 0 38px;
                    }
                    // @media (max-width: 1024px) {
                    //     margin-left: 20px;
                    //     .subtitle {
                    //         line-height: 20px;
                    //         font-size: 1.2rem;
                    //         font-style: italic;
                    //         font-weight: 550;
                    //     }
                    // }
                }
            }

            .mr-5 {
                margin-right: 30px;
            }
            .testimonial-container {
                // display: flex;
                // justify-content: center;
                // padding: 0 30px;

                margin: auto;
                margin-top: 50px;
                font-weight: lighter;

                .contacts-title {
                    font-size: 2.5rem;
                    font-weight: normal;
                    line-height: 45px;
                    font-family: GothamRounded;
                }
                .testimonial-list {
                    margin: 32px 80px;
                    display: flex;
                    justify-content: space-between;
                    align-items: start;
                    max-width: 1169px;
                    width: 100%;

                    .testimonial-card-1 {
                        border-radius: 10px;
                        margin-top: 30px;
                        height: 100%;
                        position: relative;
                        max-width: 535px;

                        .testimonial-details {
                            margin: 0 22px;
                            font-size: 0.9rem;
                            font-weight: 500;
                        }
                    }
                }
                .testimonial-card-2 {
                    border-radius: 10px;
                    margin-top: 30px;
                    height: 100%;
                    position: relative;
                    max-width: 455px;
                    .testimonial-details {
                        margin: 0 22px;
                        font-size: 0.9rem;
                        font-weight: 500;
                    }
                }

                .contacts {
                    margin: 10px;
                    width: 100%;
                    max-width: 300px;
                    .contact-no {
                        margin-top: 20px;
                    }
                    p {
                        font-size: 1.15rem;
                    }
                }
                .contacts-logo-container {
                    max-width: 90%;
                    display: flex;
                    a {
                        padding-right: 33px;
                    }
                }
            }
        }

        .contact-btn {
            color: white;
            font-weight: medium;
            background: #fa9221;
            border-radius: 10px;
            box-shadow: 4px 3px 0px 0px #1f9297;
            max-width: max-content;
            font-size: 1.2rem;
            padding: 7px 55px;
        }
    }

    .vertical-border-orange {
        border-left: 50px solid #f15c24;
        border-right: 20px solid #f79320;
        height: 400px;
    }
}
//medium
@media (min-width: 961px) and (max-width: 1264px) {
    .contacts-page {
        .contacts-section {
            margin-top: 60px;
            .contacts-banner {
                display: flex;
                align-items: center;
                background-color: #fdc321;
                padding: 0 60px;

                .avatar-container {
                    background-color: #fdc321;

                    img.img-contact1 {
                        height: 259px;
                        width: 174px;
                        object-fit: cover;
                    }
                    img.img-contact2 {
                        height: 259px;
                        width: 336px;
                        object-fit: cover;
                        object-position: 5%;
                    }

                    .center {
                        object-position: 20% 0;
                    }
                    .left {
                        object-position: 80% 0;
                    }
                    .mr-1 {
                        margin-right: 5px;
                    }
                }
                .text-container {
                    max-width: 350px;

                    .subtitle {
                        line-height: 22px;
                        font-size: 1rem;
                        font-style: italic;
                        font-weight: 550;
                        padding: 0 25px;
                    }
                    // @media (max-width: 1024px) {
                    //     margin-left: 20px;
                    //     .subtitle {
                    //         line-height: 20px;
                    //         font-size: 1.2rem;
                    //         font-style: italic;
                    //         font-weight: 550;
                    //     }
                    // }
                }
            }

            .mr-5 {
                margin-right: 30px;
            }
            .testimonial-container {
                // display: flex;
                // justify-content: center;
                // padding: 0 30px;

                margin: auto;
                margin-top: 50px;
                font-weight: lighter;

                .contacts-title {
                    font-size: 1.65rem;
                    font-weight: lighter;
                    line-height: 20px;
                    font-family: GothamRounded;
                }
                .testimonial-list {
                    margin: 32px 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: start;
                    max-width: 817px;
                    width: 100%;

                    .testimonial-card-1 {
                        border-radius: 10px;
                        margin-top: 30px;
                        height: 100%;
                        position: relative;
                        max-width: 299px;

                        .testimonial-details {
                            margin: 0 22px;
                            font-size: 0.7rem;
                            font-weight: 500;
                        }
                    }
                }
                .testimonial-card-2 {
                    border-radius: 10px;
                    margin-top: 30px;
                    height: 100%;
                    position: relative;
                    max-width: 322px;

                    .testimonial-details {
                        font-size: 0.7rem;
                        font-weight: 500;
                    }
                }

                .contacts {
                    margin-left: 46px;
                    width: 100%;
                    max-width: 145px;
                    .contact-no {
                        margin-top: 13px;
                    }
                    p {
                        font-size: 0.8rem;
                    }
                    v-icon {
                        font-size: 10px;
                    }
                }
                .contacts-logo-container {
                    max-width: 90%;
                    margin: 0;
                    display: flex;

                    a {
                        i {
                            font-size: 18px !important;
                        }

                        padding-right: 26px;
                    }
                }
            }
        }

        .contact-btn {
            color: white;
            font-weight: medium;
            background: #fa9221;
            border-radius: 10px;
            box-shadow: 4px 3px 0px 0px #1f9297;
            max-width: max-content;
            font-size: 0.8rem;
            padding: 4px 38px;
        }
    }

    .vertical-border-orange {
        border-left: 40px solid #f15c24;
        border-right: 15px solid #f79320;
        height: 259px;
    }
}
//small
@media (min-width: 599px) and (max-width: 961px) {
    .contacts-page {
        .contacts-section {
            margin-top: 60px;
            .contacts-banner {
                display: flex;
                align-items: center;
                background-color: #fdc321;
                padding: 0 35px;

                .avatar-container {
                    background-color: #fdc321;

                    img.img-contact1 {
                        height: 195px;
                        width: 115px;
                        object-fit: cover;
                    }
                    img.img-contact2 {
                        height: 195px;
                        width: 273px;
                        object-fit: cover;
                        object-position: 5%;
                    }

                    .center {
                        object-position: 20% 0;
                    }
                    .left {
                        object-position: 80% 0;
                    }
                    .mr-1 {
                        margin-right: 5px;
                    }
                }
                .text-container {
                    max-width: 253px;

                    .subtitle {
                        line-height: 13px !important;
                        font-size: 0.65rem;
                        font-style: italic;
                        font-weight: 550;
                        padding: 0 25px;
                    }
                    // @media (max-width: 1024px) {
                    //     margin-left: 20px;
                    //     .subtitle {
                    //         line-height: 20px;
                    //         font-size: 1.2rem;
                    //         font-style: italic;
                    //         font-weight: 550;
                    //     }
                    // }
                }
            }

            .mr-5 {
                margin-right: 30px;
            }
            .testimonial-container {
                // display: flex;
                // justify-content: center;
                // padding: 0 30px;

                margin: auto;
                margin-top: 30px;
                font-weight: lighter;

                .contacts-title {
                    font-size: 1.12rem;
                    font-weight: lighter;
                    line-height: 10px;
                    font-family: GothamRounded;
                }
                .testimonial-list {
                    margin: 32px 43px 32px 52px;
                    display: flex;
                    justify-content: space-between;
                    align-items: start;
                    max-width: 917px;
                    width: 100%;

                    .testimonial-card-1 {
                        border-radius: 10px;
                        margin-top: 30px;
                        height: 100%;
                        position: relative;
                        max-width: 299px;

                        .testimonial-details {
                            margin: 0 22px;
                            font-size: 0.6rem;
                            font-weight: 500;
                        }
                    }
                }
                .testimonial-card-2 {
                    border-radius: 10px;
                    margin-top: 30px;
                    height: 100%;
                    position: relative;
                    max-width: 276px;

                    .testimonial-details {
                        font-size: 0.6rem;
                        font-weight: 500;
                    }
                }

                .contacts {
                    margin-left: 46px;
                    width: 100%;
                    max-width: 98px;
                    .contact-no {
                        margin-top: 13px;
                    }
                    p {
                        font-size: 0.6rem;
                    }
                    v-icon {
                        font-size: 20px;
                    }
                }
                .contacts-logo-container {
                    max-width: 90%;
                    margin: 0;
                    display: flex;
                    a {
                        padding-right: 16px;
                    }
                }
            }
        }

        .contact-btn {
            color: white;
            font-weight: medium;
            background: #fa9221;
            border-radius: 10px;
            box-shadow: 4px 3px 0px 0px #1f9297;
            max-width: max-content;
            font-size: 0.8rem;
            padding: 4px 21px;
        }
    }

    .vertical-border-orange {
        border-left: 40px solid #f15c24;
        border-right: 15px solid #f79320;
        height: 195px;
    }
}
//xs
@media (min-width: 320px) and(max-width: 599px) {
    .contacts-page {
        .contacts-section {
            .vertical-border-orange {
                background-color: #f15c24;
                height: 20px;
                width: 100%;
            }

            .text-container {
                padding: 100px 20px 50px 20px;
                margin: auto;
                .subtitle {
                    font-size: 1.3rem;
                }
            }

            .contacts-banner {
                display: flex;
                flex-direction: column;
                align-items: center;
                background-color: #fdc321;
                padding: 0;

                .avatar-container {
                    background-color: #fdc321;
                    display: flex;
                    flex-direction: column;
                    width: 100%;

                    .small-avatar {
                        margin-bottom: 5px;
                    }

                    img.img-contact1 {
                        height: 200px;
                        width: 100%;
                        object-fit: cover;
                    }
                    img.img-contact2 {
                        height: 200px;
                        width: 100%;
                        object-fit: cover;
                    }
                }
            }

            .testimonial-container {
                padding: 0;
                margin: 40px 30px;
                .contacts-title {
                    font-size: 1.55rem;
                }

                .testimonial-list {
                    margin: 40px 0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    .testimonial-card-1 {
                        margin-top: 30px;
                        height: 100%;
                        max-width: 600px;
                        text-align: center;

                        .testimonial-details {
                            margin: 0;
                            font-size: 1rem;
                            font-weight: 500;
                            img {
                                height: 60px;
                                border-radius: 10px;
                            }
                        }
                    }
                    .testimonial-card-2 {
                        margin-top: 50px;
                        height: 100%;
                        max-width: 600px;
                        text-align: center;

                        .testimonial-details {
                            margin: 0;
                            font-size: 1rem;
                            font-weight: 500;
                            img {
                                height: 60px;
                                border-radius: 10px;
                            }
                        }
                    }

                    .contacts {
                        text-align: center !important;
                        padding-top: 20px;
                        margin-top: 65px auto;
                        max-width: 300px;
                        p {
                            font-weight: lighter;
                            font-size: 1rem;
                        }
                        .contact-no {
                            margin: 0 auto;
                            padding-bottom: 10px;
                        }
                        .contacts-logo-container {
                            padding-left: 10px;
                            margin: 0 auto;
                        }
                    }
                    .contacts-logo-container {
                        max-width: 90%;
                        display: flex;
                        a {
                            padding-right: 33px;
                        }
                    }

                    .contact-btn {
                        color: white;
                        background: #fa9221;
                        border-radius: 10px;
                        box-shadow: 4px 3px 0px 0px #1f9297;
                        max-width: max-content;
                        font-size: 1.3rem;
                        font-weight: medium;
                        padding: 9px 71px;
                        margin-bottom: 20px !important;
                        margin: 20px auto;
                    }
                }
            }
        }
    }
}
</style>
